(function ($) {
  'use strict';

  $(function () {

    /* ---------- Journey / fit cards: tap to highlight one, tap again to clear ---------- */
    var $jCards = $('.pd-journey__card');
    $jCards.attr({ role: 'button', tabindex: '0', 'aria-pressed': 'false' }).css('cursor', 'pointer');
    function jToggle() {
      var on = !$(this).hasClass('is-active');
      $jCards.removeClass('is-active').attr('aria-pressed', 'false');
      if (on) $(this).addClass('is-active').attr('aria-pressed', 'true');
    }
    $jCards.on('click', jToggle).on('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); jToggle.call(this); }
    });

    /* ---------- Reviews grid (tiles + Swiper carousel + modal) ---------- */
    function reviewTile(rv) {
      var stars = '';
      for (var i = 1; i <= 5; i++) stars += i <= rv.r ? '★' : '☆';
      var $card = $('<button type="button" class="pd-review-card swiper-slide"></button>');
      var $head = $('<div class="pd-review-card__head"></div>');
      $('<strong class="pd-review-card__name"></strong>').text(rv.n).appendTo($head);
      $('<span class="pd-review-card__stars"></span>').text(stars).appendTo($head);
      $card.append($head);
      if (rv.d) $('<span class="pd-review-card__date"></span>').text('Verified customer · ' + rv.d).appendTo($card);
      $('<p class="pd-review-card__title"></p>').text(rv.t || '').appendTo($card);
      $('<p class="pd-review-card__text"></p>').text('“' + rv.b + '”').appendTo($card);
      $('<span class="pd-review-card__readmore"></span>').text('Read more').appendTo($card);
      return $card;
    }
    function initReviewModal($cards) {
      var $modal = $('#pd-review-modal');
      if (!$modal.length || !$cards.length) return;
      var $prev = $('#pd-review-modal-prev');
      var $next = $('#pd-review-modal-next');
      var current = 0;
      function openAt(i) {
        current = Math.max(0, Math.min(i, $cards.length - 1));
        var $c = $cards.eq(current);
        $modal.find('.js-review-modal-name').text($c.find('.pd-review-card__name').text());
        $modal.find('.js-review-modal-meta').text($c.find('.pd-review-card__date').text());
        $modal.find('.js-review-modal-stars').text($c.find('.pd-review-card__stars').text());
        $modal.find('.js-review-modal-title').text($c.find('.pd-review-card__title').text());
        $modal.find('.js-review-modal-text').text($c.find('.pd-review-card__text').text());
        $modal.find('.js-review-modal-count').text((current + 1) + ' / ' + $cards.length);
        $prev.prop('disabled', current === 0);
        $next.prop('disabled', current === $cards.length - 1);
        $modal.addClass('open');
      }
      function close() { $modal.removeClass('open'); }
      $cards.each(function (i) { $(this).on('click', function () { openAt(i); }); });
      $modal.on('click', function (e) { if (e.target === this) close(); });
      $modal.find('.pd-review-modal__close').on('click', close);
      $prev.on('click', function () { if (current > 0) openAt(current - 1); });
      $next.on('click', function () { if (current < $cards.length - 1) openAt(current + 1); });
      $(document).on('keydown', function (e) {
        if (!$modal.hasClass('open')) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft' && current > 0) openAt(current - 1);
        else if (e.key === 'ArrowRight' && current < $cards.length - 1) openAt(current + 1);
      });
    }
    function initReviewsGrid() {
      var $grid = $('#pd-review-grid');
      if (!$grid.length) return;
      var $cards = $grid.children('.pd-review-card');
      /* read every card's size first, then write the classes (interleaving them forced a reflow per card) */
      var clamped = [];
      $cards.each(function () {
        var text = this.querySelector('.pd-review-card__text');
        if (text && text.scrollHeight > text.clientHeight + 1) clamped.push(this);
      });
      clamped.forEach(function (el) { el.classList.add('is-clamped'); });
      var $count = $('#pd-review-count');
      var $prevBtn = $('#pd-review-prev');
      var $nextBtn = $('#pd-review-next');
      var total = $cards.length;
      function perView(sw) {
        var v = sw && sw.params.slidesPerView;
        var spv = parseFloat(v) || 1;
        return spv;
      }
      function renderCount(sw) {
        if (!total) { $count.text(''); return; }
        var spv = Math.max(1, Math.floor(perView(sw)));
        var from = sw ? sw.activeIndex + 1 : 1;
        var to = Math.min(total, from + spv - 1);
        $count.text(from + (to > from ? '–' + to : '') + ' of ' + total + ' customer reviews');
        $prevBtn.prop('disabled', sw ? sw.isBeginning : true);
        $nextBtn.prop('disabled', sw ? sw.isEnd : true);
      }
      if (window.Swiper && total) {
        var rvSwiper = new window.Swiper('#pd-review-swiper', {
          slidesPerView: 1.1,
          spaceBetween: 14,
          watchOverflow: true,
          a11y: false,
          breakpoints: {
            560: { slidesPerView: 2, spaceBetween: 16 },
            900: { slidesPerView: 3, spaceBetween: 18 },
            1200: { slidesPerView: 4, spaceBetween: 20 }
          },
          on: { init: renderCount, slideChange: renderCount, resize: renderCount, breakpoint: renderCount }
        });
        $prevBtn.on('click', function () { rvSwiper.slidePrev(); });
        $nextBtn.on('click', function () { rvSwiper.slideNext(); });
      } else {
        $count.text(total ? total + ' customer reviews' : '');
        $prevBtn.hide(); $nextBtn.hide();
      }
      initReviewModal($cards);
    }
    function startReviews() {
      var reviewsSrc = $('#pd-review-grid').attr('data-reviews-src');
      if (reviewsSrc) {
        $.getJSON(reviewsSrc).done(function (list) {
          var $grid = $('#pd-review-grid');
          var frag = $('<div></div>');
          $.each(list, function (_, rv) { frag.append(reviewTile(rv)); });
          $grid.append(frag.children());
        }).always(initReviewsGrid);
      } else {
        initReviewsGrid();
      }
    }
    /* The reviews block is far below the fold and loads ~480 cards: build it only when it is about to be seen */
    var reviewsAnchor = document.getElementById('reviews') || document.getElementById('pd-review-grid');
    if (reviewsAnchor) {
      if ('IntersectionObserver' in window) {
        var reviewsIO = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) { reviewsIO.disconnect(); startReviews(); }
        }, { rootMargin: '900px 0px' });
        reviewsIO.observe(reviewsAnchor);
      } else {
        startReviews();
      }
    }

    /* ---------- Ingredient row carousel (Swiper) ---------- */
    /* The selected ingredient (not the scroll position) drives the dots, the arrows and the detail panel, and is
       kept centred in the row, so the highlighted dot, the highlighted tile and the panel always agree. */
    var ingSwiper = null;
    var ingRenderDetail = null; /* set by the detail-panel block below */
    function ingItems() { return $('.js-pd-ing-item'); }
    function selectedIngIndex() {
      var i = ingItems().index(ingItems().filter('.active').first());
      return i < 0 ? 0 : i;
    }
    function renderIngDots() {
      var $el = $('#pd-ing-pagination');
      var total = ingItems().length;
      if (!$el.length || !total) return;
      var active = selectedIngIndex();
      /* Clarity (28 Oct 2026) showed 8 dead taps on this row on mobile: a 10px dot is too small to hit. The dot keeps its look
         (background-clip: content-box) but gets padding so its tap area fills the row height; the gap moves into the padding. */
      $el.empty().css('gap', '0');
      for (var i = 0; i < total; i++) {
        var $dot = $('<span></span>').css({
          display: 'inline-block',
          boxSizing: 'content-box',
          backgroundClip: 'content-box',
          padding: '15px 3px',
          height: '10px',
          borderRadius: '99px',
          cursor: 'pointer',
          transition: 'all 0.3s',
          background: i === active ? '#FF6000' : '#D0CBCA',
          width: i === active ? '26px' : '10px'
        });
        (function (index) { $dot.on('click', function () { selectIngredient(index); }); })(i);
        $el.append($dot);
      }
      $('#pd-ing-prev').prop('disabled', active === 0).toggleClass('swiper-button-disabled', active === 0);
      $('#pd-ing-next').prop('disabled', active === total - 1).toggleClass('swiper-button-disabled', active === total - 1);
    }
    function selectIngredient(index) {
      var $items = ingItems();
      if (!$items.length) return;
      index = Math.max(0, Math.min($items.length - 1, index));
      $items.removeClass('active');
      var $item = $items.eq(index).addClass('active');
      if (ingRenderDetail) ingRenderDetail($item);
      if (ingSwiper) ingSwiper.slideTo(index, 300);
      renderIngDots();
    }
    if (window.Swiper && $('#pd-ing-swiper').length) {
      ingSwiper = new window.Swiper('#pd-ing-swiper', {
        slidesPerView: 'auto',
        spaceBetween: 14,
        centeredSlides: true,
        centeredSlidesBounds: true,
        on: { init: renderIngDots },
      });
    }
    $('#pd-ing-prev').on('click', function () { selectIngredient(selectedIngIndex() - 1); });
    $('#pd-ing-next').on('click', function () { selectIngredient(selectedIngIndex() + 1); });

    /* ---------- Gallery ---------- */
    var $mainImg = $('#pd-main-img');
    var $thumbScroll = $('.pd-thumb-scroll').first();
    function showThumb(thumb) {
      if (!thumb || !$mainImg.length) return;
      $('.pd-thumb').removeClass('active');
      thumb.classList.add('active');
      /* Plain src, no srcset: iOS Safari kept painting the previous picture after a scripted srcset change
         (thumbnail highlighted, old image shown). The thumbnail, already loaded, shows at once so the picture
         always matches the highlight; the 960px file replaces it as soon as it has downloaded. */
      var img = $mainImg[0];
      var big = thumb.getAttribute('data-src');
      var tImg = thumb.querySelector('img');
      var lo = tImg && tImg.complete && tImg.naturalWidth ? (tImg.currentSrc || tImg.src) : '';
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = lo || big;
      img.alt = thumb.getAttribute('data-alt') || img.alt;
      if (lo && big) {
        var pre = new Image();
        pre.onload = function () { if (thumb.classList.contains('active')) img.src = big; };
        pre.src = big;
      }
    }
    $('.pd-thumb').on('click', function () { showThumb(this); });
    /* a pack with its own image (Single Bottle, Buy 2 Get 1 FREE) brings that image to the front */
    function showPackImage(pack) {
      var asset = pack && pack.getAttribute('data-image-asset');
      if (!asset) return;
      var thumb = $('.pd-thumb').filter(function () { return this.getAttribute('data-asset') === asset; })[0];
      if (!thumb || thumb.classList.contains('active')) return;
      showThumb(thumb);
      if ($thumbScroll.length) {
        var box = $thumbScroll[0];
        box.scrollTo({ left: thumb.offsetLeft - (box.clientWidth - thumb.offsetWidth) / 2, behavior: 'smooth' });
      }
    }
    if ($thumbScroll.length) {
      $('#pd-thumb-prev').on('click', function () { $thumbScroll.animate({ scrollLeft: '-=200' }, 300); });
      $('#pd-thumb-next').on('click', function () { $thumbScroll.animate({ scrollLeft: '+=200' }, 300); });
    }

    /* ---------- Pack selector + qty + totals ---------- */
    var packs = $('.pd-pack').get();
    var qty = 1;
    var selectedPack = packs.find(function (p) { return $(p).hasClass('selected'); }) || packs[0];

    var $qtyValues = $('.js-pd-qty-value');
    var $buyBtns = $('.js-pd-buy-now');
    var $cartBtns = $('.js-pd-add-cart');
    var $promoName = $('#pd-promo-name');
    var $promoSummary = $('#pd-promo-summary');
    var $promoBtn = $('#pd-promo-btn');

    function renderTotals() {
      if (!selectedPack) return;
      var $selectedPack = $(selectedPack);
      var price = parseFloat($selectedPack.data('price'));
      var total = window.SK.fmt(price * qty);
      $qtyValues.text(String(qty));
      $buyBtns.text('Buy Now - ' + total);
      $cartBtns.attr('data-price', $selectedPack.data('price')).attr('data-name', $selectedPack.data('name'));
      $buyBtns.attr('data-price', $selectedPack.data('price')).attr('data-name', $selectedPack.data('name'));
      $promoName.text($selectedPack.data('name'));
      $promoSummary.text($selectedPack.data('summary'));
      $promoBtn.text('Add Selected Pack - ' + total);
      $('#pd-sticky-total').text(total);
    }

    $(packs).on('click', function () {
      $(packs).removeClass('selected');
      $(this).addClass('selected');
      selectedPack = this;
      renderTotals();
      showPackImage(this);
    });

    $('.js-pd-qty-down').on('click', function () { qty = Math.max(1, qty - 1); renderTotals(); });
    $('.js-pd-qty-up').on('click', function () { qty = Math.min(9, qty + 1); renderTotals(); });

    /* Shopify AJAX cart: the selected pack carries its variant id. */
    function selectedItem() {
      return { id: selectedPack ? $(selectedPack).attr('data-variant-id') : null, quantity: qty };
    }
    $cartBtns.on('click', function () {
      window.SK.addToCart(selectedItem(), false);
    });
    $buyBtns.on('click', function () {
      window.SK.addToCart(selectedItem(), true, this);
    });
    if ($promoBtn.length) {
      $promoBtn.on('click', function () {
        window.SK.addToCart(selectedItem(), true, this);
      });
    }

    /* Touching the buy box (pack, qty, cart, Buy Now) is a strong buying signal: fetch the GoKwik SDK now
       rather than at the next idle moment, so Buy Now opens checkout without a wait. */
    $(document).one('pointerdown touchstart', '.pd-pack, .pd-qty, .pd-sticky-bar, .js-pd-add-cart, .js-pd-buy-now', function () {
      if (!window.gokwikSdk && window.skLoadGokwik) window.skLoadGokwik();
    });

    renderTotals();

    /* ---------- Sticky buy bar ----------
       Shown whenever the in-page Buy Now button isn't fully on screen, including on arrival on a phone where it
       starts below (or right at the edge of) the first screen, so price + Buy Now are always in view. */
    var $stickyBar = $('#pd-sticky-bar');
    var buyEl = document.querySelector('.pd-top .js-pd-buy-now');
    if ($stickyBar.length) {
      var setBar = function (show) {
        $stickyBar.toggleClass('visible', show);
        $('body').toggleClass('pd-bar-on', show);
      };
      if (buyEl && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          setBar(entries[0].intersectionRatio < 0.99);
        }, { threshold: [0, 0.99] }).observe(buyEl);
      } else {
        $(window).on('scroll', function () { setBar($(window).scrollTop() > 320); });
      }
    }

    /* ---------- UGC videos (scroll buttons; card click opens shared modal via main.js) ---------- */
    var $ugcScroll = $('.pd-ugc__scroll').first();
    if ($ugcScroll.length) {
      $('#pd-ugc-prev').on('click', function () { $ugcScroll.animate({ scrollLeft: '-=520' }, 300); });
      $('#pd-ugc-next').on('click', function () { $ugcScroll.animate({ scrollLeft: '+=520' }, 300); });
    }

    /* ---------- Fit checklist ---------- */
    var fitResults = {
      3: { icon: '✅', title: "Sugar Knocker looks like a good fit.", copy: "You match the profile it's formulated for - a broad, plant-based daily routine alongside your existing care. Start with the Buy 2 Get 1 pack for a full 3-month routine.", cta: 'Choose your pack', href: '#top', state: 'good' },
      2: { icon: '🤔', title: 'Probably a fit - one quick check.', copy: "You're close. If your reading is under 140 or you'd rather focus on a single ingredient, Berberine Advanced or the Herbal Tea may suit you better.", cta: 'Book a FREE consultation', href: '/pages/book-consultation#book-consultation', state: 'mid' },
      1: { icon: '💬', title: "Let's find the right product together.", copy: 'One match is not enough to say. A free 30-minute call with our medical team will point you to the right routine - or tell you if none is needed.', cta: 'Book a FREE consultation', href: '/pages/book-consultation#book-consultation', state: 'low' },
      0: { icon: '☝️', title: 'Tick the statements that apply to you.', copy: 'Your answers update this panel instantly and point you to the right next step - Sugar Knocker, a companion product, or a free consultation.', cta: 'Book a FREE consultation', href: '/pages/book-consultation#book-consultation', state: 'low' }
    };
    var fitChecks = $('.pd-fit__check').get();
    var $fitResultEl = $('#pd-fit-result');
    function renderFit() {
      var n = fitChecks.filter(function (c) { return $(c).hasClass('on'); }).length;
      var r = fitResults[Math.min(n, 3)] || fitResults[0];
      if (!$fitResultEl.length) return;
      $fitResultEl.attr('data-state', r.state);
      $fitResultEl.find('.js-fit-icon').text(r.icon);
      $fitResultEl.find('.js-fit-count').text(n + ' of ' + fitChecks.length + ' apply');
      $fitResultEl.find('.js-fit-title').text(r.title);
      $fitResultEl.find('.js-fit-copy').text(r.copy);
      $fitResultEl.find('.js-fit-cta').text(r.cta).attr('href', r.href);
    }
    $(fitChecks).on('click', function () {
      var $check = $(this);
      $check.toggleClass('on');
      $check.find('.pd-fit__check-box').text($check.hasClass('on') ? '✓' : '');
      renderFit();
    });
    renderFit();

    /* ---------- Ingredient grid detail panel (inline, below the icon row) ---------- */
    var $pdIngItems = $('.js-pd-ing-item');
    var $pdIngDetail = $('#pd-ing-detail');
    if ($pdIngItems.length && $pdIngDetail.length) {
      function renderPdIngDetail($item) {
        $('#pd-ing-detail-img').attr('src', $item.data('img')).attr('alt', $item.data('name'));
        $('#pd-ing-detail-botanical').text($item.data('botanical'));
        $('#pd-ing-detail-name').text($item.data('name'));
        $('#pd-ing-detail-summary').text($item.data('summary'));
        var $safetyEl = $('#pd-ing-detail-safety');
        if ($item.data('safety')) { $safetyEl.text($item.data('safety')).prop('hidden', false); }
        else { $safetyEl.prop('hidden', true); }
        window.SK.renderStudies($item.data('studies'));
      }
      ingRenderDetail = renderPdIngDetail;
      $pdIngItems.on('click', function () {
        selectIngredient($pdIngItems.index(this));
      });
      renderPdIngDetail($pdIngItems.filter('.active').first().length ? $pdIngItems.filter('.active').first() : $pdIngItems.first().addClass('active'));
      renderIngDots();
    }

    /* ---------- PPBS dose calculator ---------- */
    var tiers = [
      { id: 0, min: 140, max: 199, caps: 2, code: '1-0-1', sched: [1, 0, 1], color: '#9EAC3A' },
      { id: 1, min: 200, max: 299, caps: 3, code: '1-1-1', sched: [1, 1, 1], color: '#FFB020' },
      { id: 2, min: 300, max: 999, caps: 6, code: '2-2-2', sched: [2, 2, 2], color: '#FF6000' }
    ];
    var $ppbsOut = $('#ppbs-out');
    var $ppbsSlider = $('#ppbs-slider');
    var $doseTierBtns = $('.pd-dose__tier');
    var $slotEls = $('.pd-dose__slot');

    function renderDose(ppbs) {
      ppbs = Math.max(100, Math.min(400, ppbs));
      $ppbsOut.text(ppbs + ' mg/dl');
      $ppbsSlider.val(ppbs).attr('aria-valuetext', ppbs + ' mg/dl');
      $ppbsSlider[0].style.setProperty('--fill', ((ppbs - 100) / 300) * 100 + '%');
      var cur = ppbs < 140 ? null : (tiers.filter(function (t) { return ppbs >= t.min && ppbs <= t.max; })[0] || tiers[2]);
      var sched = cur ? cur.sched : [0, 0, 0];
      var caps = cur ? cur.caps : 0;
      $doseTierBtns.each(function (i) { $(this).toggleClass('active', !!cur && cur.id === i); });
      $('#pd-dose-caps').text(cur ? String(caps) : '0');
      $('#pd-dose-caps-inline').text(cur ? String(caps) : '0');
      $('#pd-dose-code').text(cur ? cur.code : 'Below range');
      $('#pd-dose-badge').css('background', cur ? cur.color : '#3A3637');
      $('#pd-dose-days').text(cur ? String(Math.floor(90 / caps)) : '-');
      $slotEls.each(function (i) {
        var $slot = $(this);
        var n = sched[i];
        var $pillsWrap = $slot.find('.pd-dose__slot-pills');
        $pillsWrap.empty();
        for (var k = 0; k < n; k++) {
          $pillsWrap.append('<span class="pd-dose__pill"></span>');
        }
        if (n === 0) {
          $pillsWrap.append('<span class="pd-dose__slot-none">-</span>');
        }
        $slot.find('.pd-dose__slot-n').text(String(n));
      });
    }
    $ppbsSlider.on('input', function () { renderDose(parseInt($ppbsSlider.val(), 10) || 100); });
    $doseTierBtns.each(function (i) {
      $(this).on('click', function () { renderDose(i === 2 ? 300 : tiers[i].min); });
    });
    if ($ppbsSlider.length) renderDose(parseInt($ppbsSlider.val(), 10) || 180);

    /* ---------- Companion cross-sell (Berberine Advanced) ---------- */
    var $companionCard = $('.pd-companion-card').first();
    if ($companionCard.length) {
      var $compPackBtns = $companionCard.find('.sk-pack-option');
      var $compImg = $companionCard.find('.js-comp-img');
      var $compPrice = $companionCard.find('.js-comp-price');
      var $compMrp = $companionCard.find('.js-comp-mrp');
      var $compNote = $companionCard.find('.js-comp-note');
      var $compAddBtn = $companionCard.find('.js-comp-add');
      $compPackBtns.on('click', function () {
        var $btn = $(this);
        $compPackBtns.removeClass('selected');
        $btn.addClass('selected');
        if ($compImg.length) $compImg.removeAttr('srcset').attr('src', $btn.data('img'));
        if ($compPrice.length) $compPrice.text(window.SK.fmt(parseFloat($btn.data('price'))));
        if ($compMrp.length) { var mrp = parseFloat($btn.data('mrp')); $compMrp.prop('hidden', !mrp); if (mrp) $compMrp.text(window.SK.fmt(mrp)); }
        if ($compNote.length) $compNote.text($btn.data('note'));
        if ($compAddBtn.length) { $compAddBtn.attr('data-price', $btn.data('price')).attr('data-name', $btn.data('name')).attr('data-variant-id', $btn.attr('data-variant-id')); }
      });
      if ($compAddBtn.length) {
        $compAddBtn.on('click', function () {
          window.SK.addToCart({ id: $compAddBtn.attr('data-variant-id') }, false);
          $compAddBtn.addClass('added');
          $compAddBtn.find('.js-comp-add-label').text('Added ✓');
          clearTimeout($compAddBtn.data('t'));
          $compAddBtn.data('t', setTimeout(function () {
            $compAddBtn.removeClass('added');
            $compAddBtn.find('.js-comp-add-label').text('Add to Cart');
          }, 2800));
        });
      }
    }

    /* ---------- Safety checklist ---------- */
    var safetyItems = $('.pd-safety__item').get();
    var $safetyDetail = $('#pd-safety-detail');
    function renderSafety(item) {
      if (!item || !$safetyDetail.length) return;
      var $item = $(item);
      $safetyDetail.find('.js-safety-icon').text($item.data('icon')).css('background', $item.data('level-bg'));
      $safetyDetail.find('.js-safety-level').text($item.data('level')).css('color', $item.data('level-color'));
      $safetyDetail.find('.js-safety-title').text($item.data('title'));
      $safetyDetail.find('.js-safety-copy').text($item.data('copy'));
      var $stepsWrap = $safetyDetail.find('.js-safety-steps');
      $stepsWrap.empty();
      JSON.parse($item.attr('data-steps')).forEach(function (text, i) {
        var $row = $('<div class="pd-safety__step"><span class="pd-safety__step-n"></span><span></span></div>');
        $row.find('.pd-safety__step-n').text(i + 1);
        $row.find('span:last-child').text(text);
        $stepsWrap.append($row);
      });
      $safetyDetail.find('.js-safety-cta').text($item.data('cta')).attr('href', $item.data('href'));
    }
    $(safetyItems).on('click', function () {
      $(safetyItems).removeClass('on');
      $(this).addClass('on');
      renderSafety(this);
    });
    if (safetyItems.length) { $(safetyItems[0]).addClass('on'); renderSafety(safetyItems[0]); }

    /* ---------- FAQ accordion (single open at a time) ---------- */
    var $faqItems = $('.sk-faq-item');
    $faqItems.each(function () {
      var $item = $(this);
      var $toggle = $item.find('.js-faq-toggle');
      if (!$toggle.length) return;
      $toggle.on('click', function () {
        var willOpen = !$item.hasClass('open');
        $faqItems.removeClass('open').find('.js-faq-toggle').attr('aria-expanded', 'false');
        if (willOpen) {
          $item.addClass('open');
          $toggle.attr('aria-expanded', 'true');
        }
      });
    });

    /* ---------- Certifications modal ---------- */
    var $certModal = $('#pd-cert-modal');
    if ($certModal.length) {
      var $certTitle = $certModal.find('.js-cert-title');
      var $certSub = $certModal.find('.js-cert-sub');
      var $certImg = $certModal.find('.js-cert-img');
      $('.pd-cert-card').on('click', function () {
        var $card = $(this);
        $certTitle.text($card.data('name'));
        $certSub.text($card.data('sub'));
        $certImg.attr('src', $card.data('img')).attr('alt', $card.data('name'));
        $certModal.addClass('open');
      });
      $certModal.on('click', function (e) {
        if (e.target === this) $certModal.removeClass('open');
      });
      $certModal.find('.pd-cert-modal__close').on('click', function () {
        $certModal.removeClass('open');
      });
    }

    /* ---------- Gallery: hover zoom pane + full-screen viewer (zoom in / out, pan, thumbnails) ---------- */
    (function () {
      var main = document.querySelector('.pd-gallery__main');
      var mainImg = document.getElementById('pd-main-img');
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('.pd-thumb'));
      if (!main || !mainImg || !thumbs.length) return;
      var gallery = main.parentNode;
      var titleEl = document.querySelector('.pd-info__title');
      var title = titleEl ? titleEl.textContent.trim() : "";
      var ZOOM = 2.6;

      /* the zoom pane and the viewer use the larger file, fetched only when they open */
      function zoomSrc(t) { return t && (t.getAttribute('data-zoom') || t.getAttribute('data-src')); }
      function currentSrc() {
        return zoomSrc(document.querySelector('.pd-thumb.active')) || mainImg.currentSrc || mainImg.src;
      }
      function currentIndex() { return Math.max(0, thumbs.indexOf(document.querySelector('.pd-thumb.active'))); }

      /* hover: lens on the picture + enlarged pane beside it (desktop pointers only) */
      main.classList.add('pd-zoomable');
      var lens = document.createElement('div');
      lens.className = 'pd-lens';
      main.appendChild(lens);
      var pane = document.createElement('div');
      pane.className = 'pd-zoom-pane';
      pane.setAttribute('aria-hidden', 'true');
      gallery.appendChild(pane);
      var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1024px)');

      function moveZoom(e) {
        var r = main.getBoundingClientRect();
        var x = Math.min(Math.max(e.clientX - r.left, 0), r.width);
        var y = Math.min(Math.max(e.clientY - r.top, 0), r.height);
        var lw = r.width / ZOOM;
        var lx = Math.min(Math.max(x - lw / 2, 0), r.width - lw);
        var ly = Math.min(Math.max(y - lw / 2, 0), r.height - lw);
        lens.style.width = lens.style.height = lw + 'px';
        lens.style.transform = 'translate(' + lx + 'px,' + ly + 'px)';
        pane.style.backgroundPosition = (x / r.width * 100) + '% ' + (y / r.height * 100) + '%';
      }
      main.addEventListener('mouseenter', function (e) {
        if (!canHover || !canHover.matches) return;
        var r = main.getBoundingClientRect();
        pane.style.width = r.width + 'px';
        pane.style.height = r.height + 'px';
        pane.style.top = main.offsetTop + 'px';
        pane.style.backgroundImage = 'url("' + currentSrc() + '")';
        pane.style.backgroundSize = (ZOOM * 100) + '%';
        gallery.classList.add('pd-zooming');
        moveZoom(e);
      });
      main.addEventListener('mousemove', function (e) { if (gallery.classList.contains('pd-zooming')) moveZoom(e); });
      main.addEventListener('mouseleave', function () { gallery.classList.remove('pd-zooming'); });

      /* full-screen viewer */
      var v = document.createElement('div');
      v.className = 'pd-viewer';
      v.setAttribute('role', 'dialog');
      v.setAttribute('aria-modal', 'true');
      v.setAttribute('aria-label', 'Product images');
      v.innerHTML =
        '<button type="button" class="pd-viewer__close" aria-label="Close">&times;</button>' +
        '<div class="pd-viewer__stage"><img class="pd-viewer__img" alt="" draggable="false"></div>' +
        '<aside class="pd-viewer__side">' +
          '<div class="pd-viewer__tools">' +
            '<button type="button" class="pd-viewer__btn" data-z="in" aria-label="Zoom in"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21M10.5 7.5v6M7.5 10.5h6"/></svg></button>' +
            '<button type="button" class="pd-viewer__btn" data-z="out" aria-label="Zoom out"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21M7.5 10.5h6"/></svg></button>' +
          '</div>' +
          '<div class="pd-viewer__title"></div>' +
          '<div class="pd-viewer__thumbs"></div>' +
        '</aside>';
      document.body.appendChild(v);
      var vImg = v.querySelector('.pd-viewer__img');
      var stage = v.querySelector('.pd-viewer__stage');
      v.querySelector('.pd-viewer__title').textContent = title;
      var vThumbs = v.querySelector('.pd-viewer__thumbs');
      thumbs.forEach(function (t, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pd-viewer__thumb';
        b.setAttribute('aria-label', 'Image ' + (i + 1));
        var im = t.querySelector('img');
        b.innerHTML = '<img alt="" loading="lazy" decoding="async" src="' + (im ? im.getAttribute('src') : t.getAttribute('data-src')) + '">';
        /* tapping the thumbnail already on screen toggles zoom instead of doing nothing */
        b.addEventListener('click', function () {
          if (i === idx && v.classList.contains('open')) setScale(scale > 1 ? 1 : 2.5);
          else show(i);
        });
        vThumbs.appendChild(b);
      });

      var idx = 0, scale = 1, tx = 0, ty = 0, drag = null, lastFocus = null;
      function apply() {
        vImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
        stage.classList.toggle('is-zoomed', scale > 1);
      }
      function clamp() {
        var w = vImg.offsetWidth * scale, h = vImg.offsetHeight * scale;
        var mx = Math.max(0, (w - stage.clientWidth) / 2), my = Math.max(0, (h - stage.clientHeight) / 2);
        tx = Math.min(Math.max(tx, -mx), mx);
        ty = Math.min(Math.max(ty, -my), my);
      }
      function setScale(s) {
        scale = Math.min(Math.max(s, 1), 5);
        if (scale === 1) { tx = 0; ty = 0; }
        clamp(); apply();
      }
      function show(i) {
        idx = (i + thumbs.length) % thumbs.length;
        /* show the (already loaded) thumbnail at once, then the large file once it arrives, so on a slow
           connection the picture never lags behind the highlighted thumbnail after a quick run of swipes */
        var t = thumbs[idx], tImg = t.querySelector('img'), hi = zoomSrc(t);
        var lo = tImg ? (tImg.currentSrc || tImg.src) : hi;
        vImg.src = lo || hi;
        if (hi && hi !== lo) {
          var pre = new Image();
          pre.onload = function () { if (thumbs[idx] === t) vImg.src = hi; };
          pre.src = hi;
        }
        scale = 1; tx = 0; ty = 0; apply();
        Array.prototype.forEach.call(vThumbs.children, function (c, n) { c.classList.toggle('active', n === idx); });
      }
      function open() {
        lastFocus = document.activeElement;
        show(currentIndex());
        v.classList.add('open');
        document.documentElement.classList.add('pd-viewer-on');
        v.querySelector('.pd-viewer__close').focus();
      }
      function close() {
        v.classList.remove('open');
        document.documentElement.classList.remove('pd-viewer-on');
        thumbs[idx].click();   /* keep the page gallery on the image that was being viewed */
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      /* swipe left / right to step through the images, on the page and in the viewer */
      function onSwipe(el, fn) {
        var sx = 0, sy = 0, on = false;
        el.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) { on = false; return; }
          on = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
        }, { passive: true });
        el.addEventListener('touchend', function (e) {
          if (!on) return;
          on = false;
          var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            el.skSwiped = Date.now();
            fn(dx < 0 ? 1 : -1);
          }
        }, { passive: true });
      }
      function stepPage(d) {
        var t = thumbs[(currentIndex() + d + thumbs.length) % thumbs.length];
        t.click();
        var box = t.closest('.pd-thumb-scroll');
        if (box && box.scrollWidth > box.clientWidth) box.scrollTo({ left: t.offsetLeft - (box.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
      }
      if (thumbs.length > 1) {
        onSwipe(main, stepPage);
        onSwipe(stage, function (d) { if (scale === 1) show(idx + d); });
      }

      main.addEventListener('click', function (e) {
        if (main.skSwiped && Date.now() - main.skSwiped < 400) return;   /* the tap that ended a swipe */
        gallery.classList.remove('pd-zooming'); open();
      });
      pane.addEventListener('click', function () { gallery.classList.remove('pd-zooming'); open(); });
      v.querySelector('.pd-viewer__close').addEventListener('click', close);
      v.querySelector('[data-z="in"]').addEventListener('click', function () { setScale(scale * 1.5); });
      v.querySelector('[data-z="out"]').addEventListener('click', function () { setScale(scale / 1.5); });
      stage.addEventListener('dblclick', function () { setScale(scale > 1 ? 1 : 2.5); });
      stage.addEventListener('wheel', function (e) { e.preventDefault(); setScale(scale * (e.deltaY < 0 ? 1.2 : 1 / 1.2)); }, { passive: false });
      stage.addEventListener('click', function (e) { if (e.target === stage && scale === 1) close(); });
      /* drag to pan when zoomed (mouse, touch, pen) */
      stage.addEventListener('pointerdown', function (e) {
        if (scale <= 1) return;
        drag = { x: e.clientX - tx, y: e.clientY - ty };
        stage.setPointerCapture(e.pointerId);
        stage.classList.add('is-dragging');
      });
      stage.addEventListener('pointermove', function (e) {
        if (!drag) return;
        tx = e.clientX - drag.x; ty = e.clientY - drag.y; clamp(); apply();
      });
      function endDrag() { drag = null; stage.classList.remove('is-dragging'); }
      stage.addEventListener('pointerup', endDrag);
      stage.addEventListener('pointercancel', endDrag);
      document.addEventListener('keydown', function (e) {
        if (!v.classList.contains('open')) return;
        if (e.key === 'Escape') close();
        else if (e.key === '+' || e.key === '=') setScale(scale * 1.5);
        else if (e.key === '-') setScale(scale / 1.5);
        else if (e.key === 'ArrowRight') show(idx + 1);
        else if (e.key === 'ArrowLeft') show(idx - 1);
      });
    })();
  });
})(jQuery);
